module.exports = __webpack_public_path__ + "img/9.3e57de0a.png";